import type { FloorplanItem } from "@shared/types";
import { ProjectDocRepository } from "./ProjectDocRepository";

/**
 * Per-project floorplan file list. The files themselves live in Cloud Storage;
 * this collection stores metadata (name, size, storagePath, downloadUrl).
 */
class FloorplanRepository extends ProjectDocRepository<FloorplanItem[]> {
  readonly key = "floorplans";
  readonly defaultValue: FloorplanItem[] = [];
}

export const floorplanRepository = new FloorplanRepository();
